import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { useMemo } from 'react';
import SportsbookLayout from './SportsbookLayout';
import { useMarketplaceConfig } from '../../queries/marketplace';
import CasinoLayout from './CasinoLayout';
import { BetslipProvider } from '../../contexts/BetslipContext';
import ErrorPage from '../pages/ErrorPage';
import { getRoutesConfig } from '../../router/routes';
import { LAYOUT_TYPE } from '../../types/enums';
import { useCasinoAuth } from '../../hooks/useCasinoAuth';
import { SearchProvider } from '../../contexts/SearchContext';
import { ModalProvider } from '../../hooks/useDialog';
import AuthModalHandler from '../../providers/AuthModalHandler';
import MarketplaceMaintenancePage from '../pages/MarketplaceMaintenancePage';
import { AuthFormsProvider } from '../../contexts/AuthFormsContext';
import { authFormsConfig } from '../../config/skinRegistry/authForms';

const SportsbookProviders = () => (
  <BetslipProvider>
    <SearchProvider>
      <SportsbookLayout />
    </SearchProvider>
  </BetslipProvider>
);

const LayoutRouter = () => {
  useCasinoAuth();

  const { layoutType, data: marketplaceConfig } = useMarketplaceConfig();

  const maintenanceConfig = marketplaceConfig?.marketplaceConfig?.maintenance;

  const router = useMemo(() => {
    if (maintenanceConfig?.underMaintenance) {
      return createBrowserRouter([
        {
          path: '*',
          element: <MarketplaceMaintenancePage messageMap={maintenanceConfig.message} />,
        },
      ]);
    }

    const isSportsbook = layoutType === LAYOUT_TYPE.SPORTSBOOK;

    return createBrowserRouter([
      {
        path: '/',
        element: (
          <AuthFormsProvider config={authFormsConfig}>
            <ModalProvider>
              <AuthModalHandler>{isSportsbook ? <SportsbookProviders /> : <CasinoLayout />}</AuthModalHandler>
            </ModalProvider>
          </AuthFormsProvider>
        ),
        errorElement: <ErrorPage />,
        children: getRoutesConfig(layoutType),
      },
    ]);
  }, [layoutType, maintenanceConfig]);

  return <RouterProvider router={router} />;
};

export default LayoutRouter;
